<!--Start Back To Top Button--> 
	<a href="#" (click)="$event.preventDefault()" class="back-to-top"><i class='bx bxs-up-arrow-alt'></i></a>
<!--End Back To Top Button-->
<!--footer -->
<footer class="page-footer">
	<p class="mb-0">Robocodex © {{currentYear}}. All right reserved.</p>
</footer>
<!-- end footer -->
